module.exports = __webpack_public_path__ + "static/media/180002.2b863acc.png";